module.exports = __webpack_public_path__ + "assets/4f6da0b205016a477428d9d8442cea7b.svg";